import { useOktaAuth } from '@okta/okta-react';
import { useEffect } from 'react';
import {
    Outlet,
    Navigate,
    useLocation,
} from 'react-router-dom';
import { PageRoutes } from '@/app/components/router/routes';
import LoadingPage from './LoadingPage';
import { setOktaAuthInstance } from '@/app/shared/api/oktaRequestWrapper';
import { useDebtorAccount } from '@/app/shared/utils/hooks/useDebtorAccount';

export const PrivateOutlet = () => {
  const { authState, oktaAuth } = useOktaAuth();
  const location = useLocation();
  const { isInternal, initialized, debtorSettings } = useDebtorAccount();

  useEffect(() => {
    if (oktaAuth) {
      setOktaAuthInstance(oktaAuth);
    }
  }, [oktaAuth]);

  if (!authState) {
    return <LoadingPage />;
  }

  if (authState.isPending) {
    return <LoadingPage />;
  }

  if (!authState.isAuthenticated) {
    return (
      <Navigate
        to={PageRoutes.LOGIN}
        state={{
          referrer: location.pathname,
          search: location.search,
        }}
        replace
      />
    );
  }

  if (!initialized || (!isInternal && debtorSettings === null)) {
    return <LoadingPage />;
  }

  if (!isInternal && debtorSettings?.hasDebtorPortalWebAccess === false) {
    return <Navigate to={PageRoutes.ACCESS_DENIED} replace />;
  }

  return <Outlet />;
};
